import { render, staticRenderFns } from "./spiderChart.vue?vue&type=template&id=374b5fa0&scoped=true&"
import script from "./spiderChart.vue?vue&type=script&lang=js&"
export * from "./spiderChart.vue?vue&type=script&lang=js&"
import style0 from "./spiderChart.vue?vue&type=style&index=0&id=374b5fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b5fa0",
  null
  
)

export default component.exports